import gql from 'graphql-tag';

const GET_POTENTIAL_ZIP_CODES_COVERAGE = gql`
  query potentialPostalCodes($limit: Int, $query: JSON, $skip: Int) {
    potentialPostalCodes(limit: $limit, query: $query, skip: $skip) {
      data {
        id
        pharmacy_id
        potential_postal_code
      }
    }
  }
`;

export default GET_POTENTIAL_ZIP_CODES_COVERAGE;
